// External use indicator: link external assignment vars to y_U indicators
// For each external user U and each assignment variable x_U_E_R, enforce x_U_E_R <= y_U.
// Requires: model.optimizationIndexes.externalUsers, .decisionVariables, .externalUseDecisionVariables
export function buildExternalUseIndicatorConstraints(model, _params = {}) {
  const idx = model?.optimizationIndexes || {};
  const externalUsers = Array.isArray(idx.externalUsers) ? idx.externalUsers : [];
  const decisionVars = idx?.decisionVariables || {};
  const yVars = idx?.externalUseDecisionVariables || {};

  if (!externalUsers.length) return [];

  const yDeclared = new Set(Object.keys(yVars));

  const constraints = [];
  for (const [name, meta] of Object.entries(decisionVars)) {
    const uKey = meta?.userKey;
    if (!uKey) continue;
    if (!externalUsers.includes(uKey)) continue;
    const yName = `y_${uKey}`;
    if (!yDeclared.has(yName)) continue;
    // x_U_E_R - y_U <= 0
    constraints.push({ linear: { vars: [name, yName], coeffs: [1, -1] }, domain: [-100000, 0] });
  }
  return constraints;
}

